import React from "react";
import DictService from "./DictService";
import {message} from "antd";
import {DICT_KEY, getModel, refreshDict, setModel} from "../../../utils/constants";

const filterTree = (treeData, id) => {
    for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].key && treeData[i].key === id) {
            treeData.splice(i, 1);
            return;
        } else if (treeData[i].children && treeData[i].children.length > 0) {
            filterTree(treeData[i].children, id);
        }

    }
}
const OptType = {
    ADD_ROOT: 1,//跟
    ADD_SAME_LEVEL: 2,//同级
    ADD_CHILD_LEVEL: 3,//孩子
    DETAIL: 4//编辑
}
const MODEL_KEY = DICT_KEY.BASE_DICT
const storageModel = getModel(MODEL_KEY);
const dictModel = {
    state: !!storageModel ? storageModel : {
        dictTree: undefined,
        optType: OptType.ADD_ROOT,
        selectNode: null,
        selectPNode: null,
        /*supplierDict: [],
        brandDict: [],
        materialSortDict: [],
        orgDict: [],
        supplierTypeDict:[],*/
    },
    reducers: {
        setDictTree(state, payload) {//设置字典数
            state.dictTree = payload;
            setModel(MODEL_KEY, {...state});
        },
        setOptType(state, payload) {//设置操作类型
            state.optType = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectNode(state, payload) {//设置当前选择节点
            state.selectNode = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectPNode(state, payload) {//设置选择节点的父节点
            state.selectPNode = payload;
            setModel(MODEL_KEY, {...state});
        },
        deleteTreeNode(state, payload) {
            filterTree(state.dictTree, payload);
        },
        /*setSupplierDict(state, payload) {
            state.supplierDict = payload;
            setModel(MODEL_KEY, {...state});
        },
        setBrandDict(state, payload) {
            state.brandDict = payload;
            setModel(MODEL_KEY, {...state});
        },
        setMaterialSortDict(state, payload) {
            state.materialSortDict = payload;
            setModel(MODEL_KEY, {...state});
        },
        setOrgDict(state, payload) {
            state.orgDict = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSupplierTypeDict(state, payload) {
            state.supplierTypeDict = payload;
            setModel(MODEL_KEY, {...state});
        }*/
    },
    effects: (dispatch) => ({
        async loadDictTree() {
            const funName = "加载字典";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let dictTree = await DictService.listTree();
                this.setDictTree(dictTree);
                message.success(sucMsg, 5);
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },
        async insertDict(payload) {
            const funName = "新增字典";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let retData = await DictService.insert(payload);
                //edited by wangjialin ---------begin
                if (retData) {
                    const {cmDict} = dispatch;
                    const {pcode} = payload;
                    // console.log(pcode)
                    if (!pcode) {
                        await refreshDict(retData, cmDict);
                    } else {
                        await refreshDict(pcode, cmDict);
                    }
                }
                //------------end
                // console.log(retData)
                await this.loadDictTree();
                message.success(sucMsg, 10);
                return retData;
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },
        async updateDict(payload) {
            const funName = "修改字典";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let retData = await DictService.update(payload);
                if (retData) {
                    const {pcode} = payload;
                    if (pcode) {
                        const {cmDict} = dispatch;
                        await refreshDict(pcode, cmDict);
                    }
                }
                this.loadDictTree()
                message.success(sucMsg, 10);
                return retData;
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },
        async deleteDict(payload) {
            const funName = "删除字典";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                // return console.log(payload)
                let retData = await DictService.deleteOne(payload.id);
                if (retData) {
                    const {pcode} = payload;
                    if (pcode) {
                        const {cmDict} = dispatch;
                        await refreshDict(pcode, cmDict);
                    }
                }
                this.deleteTreeNode(payload);
                this.loadDictTree()
                message.success(sucMsg, 10);
                return retData
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }

        },
        async loadID(_, {dict}) {
            const {optType, selectPNode, selectNode} = dict;
            // console.log(selectPNode)
            let pid = null;
            if (optType === OptType.ADD_SAME_LEVEL) {
                pid = selectPNode.dictCode;
            } else if (optType === OptType.ADD_CHILD_LEVEL) {
                pid = selectNode.dictCode;
            }

            console.log(pid)
            const funName = "生成ID";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            try {
                let retData = await DictService.generateID(pid);
                message.success(sucMsg, 5);
                return retData;
            } catch (e) {
                if (e && e.retData && e.retCode) {
                    message.error(`错误码：${e.retCode};错误信息:${e.retMsg};${e.retData ? '错误数据:${e.retData}' : ''}`, 5);
                } else {
                    message.error(failMsg, 5);
                    console.log(e);
                }
            }
        },

    }),
}

export {
    OptType
}
export default dictModel;